// Static, non-pricing config for the estimate tool. Pricing lives in Firestore
// (see the seed script) and is applied server-side — never hard-coded here.

export const COMPANY = {
  name: 'West Boca Water Heater',
  shortName: 'West Boca',
  phone: '(561) 600-8358',
  serviceArea: 'Boca Raton, Delray Beach & Boynton Beach',
}

// Never Cold membership — headline savings shown on the verdict screen.
// (Full membership billing is Phase 2; this is display-only for now.)
export const NEVER_COLD = {
  name: 'Never Cold',
  replacementSavings: 150,
  blurb: 'Members save $150 on this job, plus an annual flush + inspection and priority same-day dispatch.',
}

// Step 1 — symptom picker. repairClass drives the honest repair-vs-replace
// lean, but AGE is always the dominant factor in the server-side logic.
export const SYMPTOMS = [
  {
    key: 'no_hot_water',
    label: 'No hot water',
    emoji: '🥶',
    repairClass: 'repairable',
    blurb: 'Often a heating element, thermostat, or gas control valve — frequently a repair, not a replacement.',
  },
  {
    key: 'leaking',
    label: 'Leaking',
    emoji: '💧',
    repairClass: 'replace-leaning',
    blurb: "If the tank itself is leaking, it can't be repaired. A loose fitting or valve sometimes can.",
  },
  {
    key: 'not_enough_hot_water',
    label: 'Not enough hot water',
    emoji: '♨️',
    repairClass: 'repairable',
    blurb: 'Could be a thermostat, a worn dip tube, or simply an undersized tank.',
  },
  {
    key: 'strange_noises',
    label: 'Strange noises',
    emoji: '🔊',
    repairClass: 'repairable',
    blurb: 'Usually sediment buildup at the bottom of the tank — often solved with a flush.',
  },
  {
    key: 'rusty_water',
    label: 'Rusty or discolored water',
    emoji: '🟤',
    repairClass: 'replace-leaning',
    blurb: 'Can be a worn anode rod — or internal tank corrosion, which means it needs replacing.',
  },
  {
    key: 'just_checking',
    label: 'Just checking my unit',
    emoji: '🔍',
    repairClass: 'info',
    blurb: "Smart move. Let's find out how much life it has left.",
  },
]

export function getSymptom(key) {
  return SYMPTOMS.find((s) => s.key === key) || null
}

// Manual-entry fallback options (Step 2 fallback when the photo can't be read).
export const BRANDS = [
  'Rheem',
  'Ruud',
  'A.O. Smith',
  'Bradford White',
  'State',
  'GE',
  'Whirlpool',
  'Kenmore',
  'Reliance',
  'American',
  'Richmond',
  "I'm not sure",
]

export const FUEL_TYPES = [
  { key: 'electric', label: 'Electric' },
  { key: 'gas', label: 'Gas (natural or propane)' },
  { key: 'unknown', label: "I'm not sure" },
]

export const GALLON_OPTIONS = [30, 40, 50, 55, 65, 75, 80]

// Booking — Step 5 time windows. No payment collected in this flow.
export const TIME_WINDOWS = [
  { key: 'morning', label: 'Morning', detail: '8am – 12pm' },
  { key: 'afternoon', label: 'Afternoon', detail: '12pm – 4pm' },
  { key: 'evening', label: 'Evening', detail: '4pm – 7pm' },
  { key: 'asap', label: 'ASAP / Emergency', detail: 'First available' },
]

// Client-facing estimate disclaimer (plan §5.7 — attorney to refine).
export const DISCLAIMER =
  'This is an estimate based on the information and photos you provided. Your final price is confirmed by your technician on-site before any work begins. Any additional work is shown to you for approval, with photos, before it is performed. You pay nothing until the job is done.'
